// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React, {useEffect, useRef, useState} from 'react';

import {
  AccountIcon,
  AccountIconLocation,
} from '../../../pages/Billing/AccountSettings/AccountIcon';
import {useViewer} from '../../../state/viewer/hooks';
import {useAdminModeActive} from '../../../util/admin';
import {maybePluralize} from '../../../util/uihelpers';
import * as S from './ProfileMenu.styles';
import {type Account, AccountType} from './types';

type AccountSelectorAccountInfoProps = {
  account: Pick<
    Account,
    | 'accountType'
    | 'isDummyAccount'
    | 'memberCount'
    | 'name'
    | 'accountPlanType'
  > | null;
  isSelectedAccount: boolean;
  location: AccountIconLocation;
};

export function AccountSelectorAccountInfo({
  account,
  isSelectedAccount,
  location,
}: AccountSelectorAccountInfoProps): JSX.Element {
  const memberCountText =
    ' · ' + maybePluralize(account?.memberCount ?? 0, 'user');

  const isAdminModeActive = useAdminModeActive();

  const viewer = useViewer();
  const isAccountSettingsHeader =
    location === AccountIconLocation.AccountSettingsHeader;
  const accountName =
    account?.accountType === AccountType.Personal &&
    account?.isDummyAccount !== true
      ? isAccountSettingsHeader
        ? viewer?.name
        : 'Personal'
      : account?.name;

  const accountNameRef = useRef<HTMLDivElement>(null);

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const element = accountNameRef.current;
    if (element) {
      const isOverflowing = element.scrollWidth > element.clientWidth;
      setShowTooltip(isOverflowing);
    }
  }, [accountName]);

  if (account == null) {
    return <></>;
  }

  return (
    <S.ProfileMenuAccountButton
      isAccountSettingsHeader={isAccountSettingsHeader}
      data-test={`account-${accountName}`}>
      <AccountIcon
        accountType={account?.accountType}
        location={location}
        isSelected={isSelectedAccount}
      />
      <S.ProfileMenuAccountTextContainer>
        {showTooltip && (
          <Tooltip
            content={accountName}
            position="top center"
            trigger={
              <S.ProfileMenuAccountName
                ref={accountNameRef}
                isAccountSettingsHeader={isAccountSettingsHeader}>
                {accountName}
              </S.ProfileMenuAccountName>
            }
          />
        )}
        {!showTooltip && (
          <S.ProfileMenuAccountName
            ref={accountNameRef}
            isAccountSettingsHeader={isAccountSettingsHeader}>
            {accountName}
          </S.ProfileMenuAccountName>
        )}
        <S.ProfileMenuAccountInfo
          isAccountSettingsHeader={isAccountSettingsHeader}>
          {account?.accountType === AccountType.Personal
            ? isAccountSettingsHeader
              ? 'Personal'
              : 'Free'
            : `${
                isAdminModeActive
                  ? account?.accountPlanType
                  : account?.accountType
              }${memberCountText}`}
        </S.ProfileMenuAccountInfo>
      </S.ProfileMenuAccountTextContainer>
    </S.ProfileMenuAccountButton>
  );
}
